import { render, staticRenderFns } from "./SecureLinkInformation.vue?vue&type=template&id=46b943b0&"
import script from "./SecureLinkInformation.vue?vue&type=script&lang=js&"
export * from "./SecureLinkInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46b943b0')) {
      api.createRecord('46b943b0', component.options)
    } else {
      api.reload('46b943b0', component.options)
    }
    module.hot.accept("./SecureLinkInformation.vue?vue&type=template&id=46b943b0&", function () {
      api.rerender('46b943b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/View/Recipients/SecureLinkInformation.vue"
export default component.exports